/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RevokeServiceAccountDtoBase
 * auto generated base class for the model RevokeServiceAccountDtoModel.
 */
export const RevokeServiceAccountDtoModelBase = ModelBase
  .named('RevokeServiceAccountDto')
  .props({
    __typename: types.optional(types.literal("RevokeServiceAccountDto"), "RevokeServiceAccountDto"),
    revoked: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RevokeServiceAccountDtoModelSelector extends QueryBuilder {
  get revoked() { return this.__attr(`revoked`) }
}
export function selectFromRevokeServiceAccountDto() {
  return new RevokeServiceAccountDtoModelSelector()
}

export const revokeServiceAccountDtoModelPrimitives = selectFromRevokeServiceAccountDto().revoked
